import { TOPIC_TAGS } from '../lib/constants';
import { useI18n } from '../i18n';

interface Props {
  value: string[];
  onChange: (value: string[]) => void;
  labelledBy: string;
  describedBy?: string;
  /** The session's question set (0017); all topics when not given. */
  allowed?: readonly string[] | null;
}

// Domain-pick tiles (two across, emoji + label), multi-select toggle buttons.
// Selected = aria-pressed, ✓ mark and a 3:1 ring (not colour alone).
export function TopicTags({ value, onChange, labelledBy, describedBy, allowed }: Props) {
  const { t } = useI18n();
  function toggle(tag: string) {
    onChange(value.includes(tag) ? value.filter((v) => v !== tag) : [...value, tag]);
  }

  return (
    <div className="sx-topics" role="group" aria-labelledby={labelledBy} aria-describedby={describedBy}>
      {TOPIC_TAGS.filter((tag) => !allowed || allowed.includes(tag.value)).map((tag) => {
        const on = value.includes(tag.value);
        return (
          <button
            key={tag.value}
            type="button"
            aria-pressed={on}
            className={`sx-tile${on ? ' active' : ''}`}
            onClick={() => toggle(tag.value)}
          >
            <span className="emoji" aria-hidden="true">{tag.emoji}</span>
            <span>{t[`topic.${tag.value}`]}</span>
            {on && <span className="tick" aria-hidden="true">✓</span>}
          </button>
        );
      })}
    </div>
  );
}
